export default __webpack_public_path__ + "static/media/XRP-BUSD.b45287fb.png";